var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ComposedPlaceholderErrorWithButton',{attrs:{"errorProps":{
        description: _vm.$t('notifications_loading_error_description')
    },"buttonText":_vm.$t('retry')},on:{"button-click":function($event){return _vm.$emit('retry')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }